import "./Common/TickerDisplay.api";
export { TickerDisplayDesktop } from "./Desktop/TickerDisplayDesktop.container";
export { TickerDisplayMobile } from "./Mobile/TickerDisplayMobile.container";

export type TickerDisplayActions =
  | "ticker.message.set"
  | "ticker.show"
  | "ticker.hide"
  | "ticker.animation.start"
  | "ticker.animation.stop"
  | "ticker.animation.end";
